import { ReactComponent as GreenTick } from "../../img/icons/icon_tick_green.svg";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import BackButton from "../../img/icons/icon_blue_back.svg";

function UpdateEmail({ initState = null }) {
  const { t } = useTranslation();
  const history = useHistory();

  const [state, setState] = useState(
    initState || {
      email: "",
      confirmEmail: "",
    }
  );
  const [inputType1, setInput1Type] = useState("email");
  const [inputType2, setInput2Type] = useState("email");
  const [validation, setValidation] = useState({
    message: "",
    status: true,
  });

  useEffect(() => {
    validator();
  }, [state]);

  function validateEmail(inputText) {
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/;
    return inputText.match(mailformat);
  }

  function validator() {
    if (state.none) {
      setValidation({
        message: "",
        status: true,
      });
    } else if (state.email === "" || state.confirmEmail === "") {
      setValidation({
        message: t("appointment.EMAIL-VALIDATION.message1"),
        status: false,
      });
    } else if (
      !validateEmail(state.email) ||
      !validateEmail(state.confirmEmail)
    ) {
      setValidation({
        message: t("appointment.EMAIL-VALIDATION.message2"),
        status: false,
      });
    } else if (state.email !== state.confirmEmail) {
      setValidation({
        message: t("appointment.EMAIL-VALIDATION.message3"),
        status: false,
      });
    } else {
      setValidation({ message: "", status: true });
    }
  }

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // update email
  const changeEmail = async () => {
    const token = "Bearer " + localStorage.getItem("token");
    const patientId = JSON.parse(localStorage.getItem("pid"));
    const PATCH_URL = `/api/v1/users/profile/${patientId}`;
    try {
      const data = {
        email: state.email,
      };
      const response = await fetch(`${PATCH_URL}`, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
          Authorization: token.replace(/['"]+/g, ""),
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      const res = await response.json();
      console.log(res);

      if (!response.status === 200) {
        const error = new Error(response.error);
        throw error;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = () => {
    changeEmail();
    history.push("/setting");
  };

  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link to="/setting" className="icon_left d-flex align-items-center">
            <img src={BackButton} alt="" className="img-fluid" />
            <span className="head_title">{t("sidenav.EMAIL.detail")}</span>
          </Link>
        </div>
      </header>
      <div className="body_content">
        <div className="inner_body">
          <h3 className="headtitle mb-4">{t("onboard.EMAIL.question")}</h3>
          <div className="fill_form light_fill_form">
            <div className="field_group field_lbl_active">
              <label className="field_lbl">
                {t("onboard.EMAIL.inputLbl1")}
              </label>
              <input
                type={inputType1}
                className="field_input"
                placeholder=""
                name="email"
                onChange={handleChange}
                value={state.email}
                autoComplete="off"
                onFocus={() => setInput1Type("email")}
                onBlur={() => setInput1Type("password")}
              />
            </div>
            <h3 className="headtitle mb-4">{t("onboard.EMAIL.inputLbl2")}</h3>
            <div className="field_group field_lbl_active">
              <label className="field_lbl">
                {t("onboard.EMAIL.inputLbl3")}
              </label>
              <input
                type={inputType2}
                className="field_input"
                placeholder=""
                name="confirmEmail"
                onChange={handleChange}
                value={state.confirmEmail}
                autoComplete="off"
                onFocus={() => setInput2Type("email")}
                onBlur={() => setInput2Type("password")}
              />
              {validation.status === true && (
                <span className="icon">
                  <GreenTick className="img-fluid" />
                </span>
              )}
            </div>

            {validation.status !== true && state.confirmEmail !== "" && (
              <span className="txt_help " style={{ color: "red" }}>
                {validation.message}
              </span>
            )}

            <div className="btn_block d-flex justify-content-center bottom_button">
              <button
                className="btn btn_primary"
                disabled={!validation.status}
                onClick={handleClick}
                data-bs-toggle="modal"
                data-bs-target="#modal_email"
              >
                {t("appointment.BUTTON.save")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="custom_modal modal fade text-center" id="modal_email">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_email"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center pb-3">
                  {t("sidenav.EMAIL.message")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateEmail;
